// Ingredient swatches (snippets/ingredient-swatches.liquid).
//
// Product page: shows the selected fragrance's swatches over the gallery. Each gift set fragrance has
// its own set (data-variant-id); the product form's variant input changes on selection.
//
// The swap is animated (assets/ingredient-swatches.css): the old set fades out while the new one's
// images load, then the new swatches pop in. The new images start loading on selection (they're lazy
// while hidden), and the new set waits for them, up to ENTER_WAIT, so they don't pop in half-loaded.
// Choosing again mid-swap starts over from what's showing. No animation with reduced motion.
const LEAVE_MS = 180;
const ENTER_WAIT = 350;
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function showSwatchSet(gallery, variantId) {
  const sets = [...gallery.querySelectorAll("[data-variant-id]")];
  const next = sets.find((set) => set.dataset.variantId === variantId);
  const current = sets.find((set) => !set.hidden && !set.classList.contains("is-leaving")) ||
    sets.find((set) => !set.hidden);
  const swap = {};
  gallery.swatchSwap = swap;
  sets.forEach((set) => {
    set.classList.remove("is-leaving", "is-entering");
    if (set !== current) set.hidden = true;
  });
  if (!next || next === current) {
    if (next) next.hidden = false;
    return;
  }
  if (!current || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    if (current) current.hidden = true;
    next.hidden = false;
    return;
  }

  const images = [...next.querySelectorAll("img")];
  images.forEach((img) => (img.loading = "eager"));
  const loaded = Promise.all(images.map((img) => img.decode().catch(() => {})));
  current.classList.add("is-leaving");
  Promise.all([wait(LEAVE_MS), Promise.race([loaded, wait(ENTER_WAIT)])]).then(() => {
    if (gallery.swatchSwap !== swap) return;
    current.hidden = true;
    current.classList.remove("is-leaving");
    next.hidden = false;
    next.classList.add("is-entering");
  });
}

document.addEventListener("change", (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.name !== "id" || !input.form) return;
  document.querySelectorAll("[data-ingredient-swatches]").forEach((gallery) => {
    if (gallery.querySelector("[data-variant-id]")) showSwatchSet(gallery, String(input.value));
  });
});

// A head start: hovering, focusing or touching a fragrance picker tile starts loading that
// fragrance's gallery swatches, so they're usually ready by the time it's chosen. The tile's value is
// the fragrance name; the picker's variant JSON gives its variant.
function preloadSwatchesFor(tile) {
  const input = tile.previousElementSibling;
  const picker = tile.closest("fragrance-picker");
  if (!input || !picker) return;
  picker.swatchVariants ||= JSON.parse(picker.querySelector("[data-variant]")?.textContent || "[]");
  const variant = picker.swatchVariants.find((v) => v.option1 === input.value);
  if (!variant) return;
  document.querySelectorAll(`[data-ingredient-swatches] [data-variant-id="${variant.id}"] img`).forEach((img) => {
    img.loading = "eager";
  });
}
["pointerover", "focusin", "touchstart"].forEach((type) => {
  document.addEventListener(
    type,
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      // Keyboard focus lands on the tile's radio, just before it.
      const tile = target.closest(".fragrance-picker__tile") ||
        (target.matches(".fragrance-picker__input") && target.nextElementSibling);
      if (tile) preloadSwatchesFor(tile);
    },
    { passive: true },
  );
});

// Fragrance picker, on touch screens: a tap on a swatch shows its name, as hovering does elsewhere;
// tapping it again, or anywhere else, hides it.
document.addEventListener("click", (event) => {
  if (!window.matchMedia("(hover: none)").matches) return;
  const swatch = event.target instanceof Element ? event.target.closest(".ingredient-swatches--picker .ingredient-swatch") : null;
  document.querySelectorAll(".ingredient-swatches--picker .ingredient-swatch.is-active").forEach((active) => {
    if (active !== swatch) active.classList.remove("is-active");
  });
  if (swatch) swatch.classList.toggle("is-active");
});

// Cards: the height of the add to basket button that slides up on hover, so swatches set to lift
// move by exactly that much (assets/ingredient-swatches.css). Falls back to 44px.
function measureCardButton() {
  const button = document.querySelector(".product__card__thumbnail .product__cart--wrapper");
  if (button && button.offsetHeight) {
    document.documentElement.style.setProperty("--card-button-height", `${button.offsetHeight}px`);
  }
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", measureCardButton);
else measureCardButton();
window.addEventListener("resize", measureCardButton);
